.page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.container {
  overflow-y: auto;
  flex: 1;
}

.tab-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
}

.mobile-tab-selector {
  padding: 1.2rem 1.6rem 0;

  /* matches the page header's breakpoint, which is hidden below 990px */
  @media screen and (min-width: 990px) {
    display: none;
  }
}

.grid {
  width: 100%;
  padding: 1.6rem;
}

.section-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--color-grayscale-white);
  margin: 1.6rem 1.6rem 0.8rem 1.6rem;
  padding: 0;
}

.pinned-header-row {
  background: transparent;

  td {
    padding: 0 !important;
    border: none !important;
  }

  &:hover {
    background: transparent !important;
  }
}
